import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function Landing() {
  return (
    <div className="min-h-screen bg-ccc-navy text-white relative overflow-hidden flex flex-col">
      <div className="absolute -top-32 -right-24 h-[28rem] w-[28rem] rounded-full bg-ccc-blue/20 blur-3xl" />
      <div className="absolute -bottom-40 -left-24 h-96 w-96 rounded-full bg-ccc-teal/10 blur-3xl" />

      {/* Header */}
      <header className="relative z-10 max-w-5xl w-full mx-auto px-6 h-20 flex items-center justify-between">
        <Logo className="h-9" light />
        <Link
          to="/login"
          data-testid="landing-signin-link"
          className="text-sm text-slate-400 hover:text-white transition-colors underline underline-offset-4 decoration-slate-600"
        >
          Sign in
        </Link>
      </header>

      {/* Hero */}
      <main className="relative z-10 flex-1 flex items-center">
        <div className="max-w-5xl w-full mx-auto px-6 py-16 lg:py-24">
          <div className="max-w-2xl animate-fade-up">
            <span className="inline-block text-[11px] font-semibold tracking-widest uppercase text-ccc-blue2 bg-white/5 border border-white/10 rounded-full px-3 py-1">
              Acquisition Platform
            </span>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold font-head leading-[1.05] tracking-tight">
              Three acquisition engines.<br />
              <span className="text-ccc-blue2">One command center.</span>
            </h1>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10">
        <div className="max-w-5xl w-full mx-auto px-6 py-6 flex items-center justify-between text-xs text-slate-400">
          <span>© {new Date().getFullYear()} CorreCore CRM</span>
          <Link to="/login" className="hover:text-white transition-colors underline underline-offset-4">Sign in</Link>
        </div>
      </footer>
    </div>
  );
}
